import { render, staticRenderFns } from "./layer-answer-dialog.vue?vue&type=template&id=4351d250&scoped=true&"
import script from "./layer-answer-dialog.vue?vue&type=script&lang=js&"
export * from "./layer-answer-dialog.vue?vue&type=script&lang=js&"
import style0 from "./layer-answer-dialog.vue?vue&type=style&index=0&id=4351d250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4351d250",
  null
  
)

export default component.exports